/** @jsx h */
import { labels } from '../config';
import { useRef, useEffect, useState } from 'preact/hooks';

const SearchHeader = ({ query, pluginNamespace }) => {
  const [searchQuery, setSearchQuery] = useState(query);
  const searchInputEl = useRef(null);

  useEffect(() => setSearchQuery(query), [query]);

  function handleInputChange() {
    if (searchInputEl && searchInputEl.current) {
      const value = searchInputEl.current.value;
      setSearchQuery(value);
    }
  }

  return (
    <fieldset class="searchform-line">
      <label for="searchform-line__input" class="sr-only">
        {labels.search.searchFieldLabel}
      </label>
      <input
        id="search-form__input"
        class="searchform-line__input"
        data-main-input
        name={`${pluginNamespace}[q]`}
        value={searchQuery}
        ref={searchInputEl}
        onChange={handleInputChange}
        autocomplete="off"
        placeholder={labels.search.placeholder || ''}
        type="text"
      />
      {/* we need a button (hidden) submit button, to submit form */}
      <button aria-hidden="true" class="sr-only" tabindex="-1">
        submit
      </button>
    </fieldset>
  );
};

export default SearchHeader;
